/* ---------------------------------------------
 NAV MENU
 --------------------------------------------- */

export function init() {
  console.log("nav init");
  jQuery("#nav .menu-item-has-children").append(
    "<div class='chevron-icon'></div>"
  );

  jQuery("#nav .menu-item-has-children").on("mouseover", function () {
    jQuery("#nav")
      .find("img")
      .each(function () {
        if (jQuery(this).attr("data-src") != "") {
          jQuery(this).attr("src", jQuery(this).attr("data-src"));
          jQuery(this).attr("srcset", jQuery(this).attr("data-srcset"));
          jQuery(this).attr("data-src", "");
        }
      });

    jQuery("#nav .menu-item-has-children").removeClass("active");
    jQuery(this).addClass("active");
  });

  jQuery("#nav .menu-item-has-children").on("mouseout", function () {
    jQuery(this).removeClass("active");
  });

  jQuery(".wp-block-group__inner-container > .wp-block-group").on(
    "mouseout",
    function () {
      jQuery(this).parents(".wp-block-group.active").removeClass("active");
    }
  );

  jQuery(".grid-list li").remove();
  jQuery("<li class='filterstoggle'></li>").appendTo(".grid-list");
  jQuery(".grid-list").on("click", ".filterstoggle", function () {
    jQuery(".filters").toggleClass("open");
    jQuery(".filterstoggle").toggleClass("open");
  });

  jQuery(".hamburger").on("click", function (e) {
    console.log("hamburger clicked");
    jQuery("body").toggleClass("navopen");
  });

  // jQuery(".menu-item-has-children").on("click", "a", function (e) {
  //     if (jQuery("body").hasClass("navopen")) {
  //         e.stopPropagation();
  //         e.preventDefault();

  //         var thisopen = jQuery(this).closest(".menu-item-has-children").hasClass("open") ? true : false;

  //         jQuery(this).closest(".menu-item-has-children").removeClass("open");

  //         if (!thisopen) {
  //             jQuery(this).closest(".menu-item-has-children").addClass("open");
  //         }

  //     }
  // });

  jQuery("#nav .menu-item-has-children").on(
    "click",
    ".chevron-icon",
    function (e) {
      jQuery("#nav")
        .find("img")
        .each(function () {
          if (jQuery(this).attr("data-src") != "") {
            jQuery(this).attr("src", jQuery(this).attr("data-src"));
            jQuery(this).attr("srcset", jQuery(this).attr("data-srcset"));
            jQuery(this).attr("data-src", "");
          }
        });

      if (jQuery("body").hasClass("navopen")) {
        e.stopPropagation();
        var thisopen = jQuery(this)
          .closest(".menu-item-has-children")
          .hasClass("open")
          ? true
          : false;

        jQuery(this).closest(".menu-item-has-children").removeClass("open");

        if (!thisopen) {
          jQuery(this).closest(".menu-item-has-children").addClass("open");
        }
      }
    }
  );

  // jQuery(".search-action").clone().appendTo(jQuery("#main-navigation"));
}
